import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import * as ENVIRONMENT from '../../../environment';
/**
 * インラインフレーム
 *【参照先:srcUrl:string】
 *【高さ:height:string = "100%"】
 *【幅:width:string = "100%"】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-iframe',
  templateUrl: './iframe.html',
  styles: [`
    
  `]
})
export class Iframe extends BaseWidget {
  /**
   * 参照先
   */
  @Input() srcUrl:string

  /**
   * 高さ
   */
  @Input() height:string = "100%"

  /**
   * 幅
   */
  @Input() width:string = "100%"

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  public safeSite: SafeResourceUrl;
  
  ngOnInit() {
    const url = (ENVIRONMENT[this.srcUrl] ? ENVIRONMENT[this.srcUrl] : this.srcUrl) + '?v=' + Date.now();
    this.safeSite = this.injector.get(DomSanitizer).bypassSecurityTrustResourceUrl(url);
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/iframe/iframe.component.ts